import { default as Tooltip } from './Tooltip';

export * from './TooltipProps';
export default Tooltip;
